export const EAppGeneral = {
	tabAppInfo: 'tabAppInfo',
}